(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[228],{

/***/ "wvxA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/widgets/line-title/LineTitle.jsx
var LineTitle = __webpack_require__("2Ufl");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/arrow-button/ArrowButton.jsx + 1 modules
var ArrowButton = __webpack_require__("Gy6l");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// CONCATENATED MODULE: ./src/client/components/widgets/product-must-try-card/ProductMustTryCard.jsx


var __jsx = react_default.a.createElement;




var ProductMustTryCard_ProductMustTryCard = function ProductMustTryCard(_ref) {
  var className = _ref.className,
      description = _ref.description,
      id = _ref.id,
      imageSrc = _ref.imageSrc,
      _onClick = _ref.onClick,
      seeMoreLabel = _ref.seeMoreLabel,
      title = _ref.title;

  var _useState = Object(react["useState"])(false),
      isExpanded = _useState[0],
      setExpanded = _useState[1];

  return __jsx("button", {
    className: Object(classnames_utils["a" /* classnames */])('text-initial h-full w-full overflow-hidden', className),
    "data-testid": "ProductMustTryCard",
    id: id,
    onClick: function onClick() {
      _onClick === null || _onClick === void 0 ? void 0 : _onClick(isExpanded);
      setExpanded(!isExpanded);
    },
    type: "button"
  }, __jsx("span", {
    className: "relative isolate block h-full pb-50"
  }, __jsx("span", {
    className: "block overflow-hidden rounded-12 bg-lightGrey"
  }, __jsx(Image["b" /* default */], {
    altMsg: "",
    groupKey: "thumbnails",
    imageUrl: imageSrc,
    ratioKey: ratios_utils["c" /* default */].R_38_BY_28,
    ratioDisplay: 1 / 4
  })), __jsx("span", {
    className: "block max-h-55 overflow-hidden px-15 pt-15 text-center text-16 font-bold leading-tight"
  }, title), !!seeMoreLabel && __jsx("span", {
    className: "absolute inset-x-0 bottom-0 my-15 block text-center text-14 underline"
  }, seeMoreLabel), __jsx("span", {
    className: Object(classnames_utils["a" /* classnames */])('transition-transform absolute top-full mx-5 mt-5 block max-h-full transform overflow-y-auto rounded-12 bg-white px-20 pb-5 pt-20 text-center duration-250 ease-in', {
      '-translate-y-full': isExpanded,
      'translate-y-0': !isExpanded
    })
  }, __jsx("span", {
    className: "mb-20 block text-18 font-bold"
  }, title), __jsx("span", {
    className: "block text-14"
  }, description))));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/slider-handler/SliderHandler.jsx + 2 modules
var SliderHandler = __webpack_require__("A5Hi");

// CONCATENATED MODULE: ./src/client/components/widgets/product-must-try/ProductMustTryLarge.jsx

var ProductMustTryLarge_jsx = react_default.a.createElement;










var ProductMustTryLarge_ProductMustTryLarge = function ProductMustTryLarge(_ref) {
  var className = _ref.className,
      isFrench = _ref.isFrench,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      productIconName = _ref.productIconName;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  return ProductMustTryLarge_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('relative isolate -mx-20 overflow-hidden', className)
  }, ProductMustTryLarge_jsx("div", {
    className: "absolute top-0 flex h-[390px] w-full justify-center overflow-hidden rounded-12 bg-lightSand p-20"
  }, ProductMustTryLarge_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('relative px-60', {
      'pt-10': isFrench
    })
  }, ProductMustTryLarge_jsx("div", {
    className: "absolute start-0 top-0 opacity-25"
  }, ProductMustTryLarge_jsx(Icon["a" /* Icon */], {
    className: "text-sand",
    isNotSquare: true,
    name: productIconName,
    width: "8.75rem"
  })), ProductMustTryLarge_jsx(Icon["a" /* Icon */], {
    className: "text-black",
    name: isFrench ? icons["a" /* ICONS */].MUST_TRY_EXPERIENCES_FR : icons["a" /* ICONS */].MUST_TRY_EXPERIENCES,
    width: isFrench ? '11rem' : '10rem'
  }))), ProductMustTryLarge_jsx(SliderHandler["a" /* SliderHandler */], {
    className: "-mx-10",
    hasKeyboardSupport: true,
    hasLazyload: true,
    hasSwipeSupport: true,
    items: items.map(function (item) {
      return ProductMustTryLarge_jsx("div", {
        className: "relative h-full px-10",
        key: item.id
      }, ProductMustTryLarge_jsx(ProductMustTryCard_ProductMustTryCard, item));
    }),
    nbItemsToScroll: 1,
    nbItemsToShow: isDesktop ? 4 : 3
  }, function (_ref2) {
    var hasControls = _ref2.hasControls,
        isNextControlDisabled = _ref2.isNextControlDisabled,
        isPreviousControlDisabled = _ref2.isPreviousControlDisabled,
        itemsNode = _ref2.itemsNode,
        onNext = _ref2.onNext,
        onPrevious = _ref2.onPrevious;
    return ProductMustTryLarge_jsx("div", {
      className: "relative mx-20 mt-95"
    }, itemsNode, hasControls && ProductMustTryLarge_jsx("div", {
      className: "pointer-events-none absolute inset-0 flex w-full items-center justify-between"
    }, !isPreviousControlDisabled && ProductMustTryLarge_jsx(ArrowButton["a" /* ArrowButton */], {
      className: "pointer-events-auto -translate-x-1/2",
      color: colors["a" /* COLORS */].WHITE,
      label: Object(i18n["h" /* t */])('common.previous'),
      onClick: onPrevious
    }), !isNextControlDisabled && ProductMustTryLarge_jsx(ArrowButton["a" /* ArrowButton */], {
      className: "pointer-events-auto ms-auto translate-x-1/2",
      color: colors["a" /* COLORS */].WHITE,
      label: Object(i18n["h" /* t */])('common.next'),
      onClick: onNext,
      rotation: 180
    })));
  }));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/scrollable/Scrollable.jsx + 1 modules
var Scrollable = __webpack_require__("cVnM");

// CONCATENATED MODULE: ./src/client/components/widgets/product-must-try/ProductMustTryNarrow.jsx



var ProductMustTryNarrow_jsx = react_default.a.createElement;






var ProductMustTryNarrow_ProductMustTryNarrow = function ProductMustTryNarrow(_ref) {
  var className = _ref.className,
      isFrench = _ref.isFrench,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      productIconName = _ref.productIconName,
      scrollBackwardLabel = _ref.scrollBackwardLabel,
      scrollForwardLabel = _ref.scrollForwardLabel;
  return ProductMustTryNarrow_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('relative isolate', className)
  }, ProductMustTryNarrow_jsx("div", {
    className: "absolute inset-0 h-[390px] bg-lightSand p-20 text-center"
  }, ProductMustTryNarrow_jsx("div", {
    className: "absolute start-0 top-0 pt-10 opacity-25"
  }, ProductMustTryNarrow_jsx(Icon["a" /* Icon */], {
    className: "text-sand",
    isNotSquare: true,
    name: productIconName,
    width: "8.75rem"
  })), ProductMustTryNarrow_jsx(Icon["a" /* Icon */], {
    className: "text-black",
    name: isFrench ? icons["a" /* ICONS */].MUST_TRY_EXPERIENCES_FR : icons["a" /* ICONS */].MUST_TRY_EXPERIENCES,
    width: isFrench ? '12.5rem' : '10rem'
  })), ProductMustTryNarrow_jsx(Scrollable["a" /* Scrollable */], {
    backwardLabel: scrollBackwardLabel,
    className: "pt-95",
    forwardLabel: scrollForwardLabel,
    navPosition: "center"
  }, ProductMustTryNarrow_jsx("div", {
    className: "flex px-10"
  }, items.map(function (_ref2) {
    var description = _ref2.description,
        id = _ref2.id,
        imageSrc = _ref2.imageSrc,
        onClick = _ref2.onClick,
        seeMoreLabel = _ref2.seeMoreLabel,
        title = _ref2.title;
    return ProductMustTryNarrow_jsx("div", {
      key: id,
      className: "m-10 w-280 flex-none"
    }, ProductMustTryNarrow_jsx(ProductMustTryCard_ProductMustTryCard, {
      description: description,
      id: id,
      imageSrc: imageSrc,
      onClick: onClick,
      seeMoreLabel: seeMoreLabel,
      title: title
    }));
  }), ProductMustTryNarrow_jsx("div", {
    className: "pr-10"
  }))));
};
// CONCATENATED MODULE: ./src/client/components/lines/product-must-try-line/ProductMustTryLine.jsx





var ProductMustTryLine_jsx = react_default.a.createElement;








var ProductMustTryLine_ProductMustTryLine = function ProductMustTryLine(_ref) {
  var _ref$config = _ref.config;
  _ref$config = _ref$config === void 0 ? {} : _ref$config;
  var _ref$config$common = _ref$config.common;
  _ref$config$common = _ref$config$common === void 0 ? {} : _ref$config$common;
  var scrollBackward = _ref$config$common.scrollBackward,
      scrollForward = _ref$config$common.scrollForward,
      id = _ref.id,
      isFrench = _ref.isFrench,
      mustTryExperiences = _ref.mustTryExperiences,
      resort = _ref.resort,
      seeMore = _ref.seeMore,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var track = Object(useTracking["a" /* useTracking */])();
  var items = (mustTryExperiences || []).map(function (_ref2) {
    var itemId = _ref2.id,
        itemTitle = _ref2.title,
        image = _ref2.image,
        description = _ref2.description;
    return {
      description: description,
      id: itemId,
      imageSrc: image,
      onClick: function onClick(isExpanded) {
        if (!isExpanded) {
          track({
            categoryGA: 'cards',
            actionGA: 'must_try',
            labelGA: itemTitle
          });
        }
      },
      seeMoreLabel: seeMore,
      title: itemTitle
    };
  });

  if (!resort || !items.length) {
    return null;
  }

  var productColor = resort.color,
      productName = resort.name,
      productIconName = resort.icon;
  var props = {
    isFrench: isFrench,
    items: items,
    productColor: productColor,
    productIconName: productIconName
  };

  var titleNode = ProductMustTryLine_jsx(LineTitle["a" /* LineTitle */], null, Object(dist["messageFormat"])(title).format({
    productName: productName
  }));

  return isTablet ? ProductMustTryLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, titleNode, ProductMustTryLine_jsx(ProductMustTryLarge_ProductMustTryLarge, props)) : ProductMustTryLine_jsx("div", Object(esm_extends["a" /* default */])({}, id ? {
    id: id
  } : null, {
    className: "Line"
  }), ProductMustTryLine_jsx(SiteContainer["a" /* SiteContainer */], null, titleNode), ProductMustTryLine_jsx(ProductMustTryNarrow_ProductMustTryNarrow, Object(esm_extends["a" /* default */])({}, props, {
    scrollBackwardLabel: scrollBackward,
    scrollForwardLabel: scrollForward
  })));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/product-must-try-experiences/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (ProductMustTryLine_ProductMustTryLine);

/***/ })

}]);